import React from 'react';

const BreadIcon = ({ className, size = "h-6 w-6" }) => {
  return (
    <div className={`${size} relative overflow-hidden rounded-md ${className}`}>
      <img 
        src="https://customer-assets.emergentagent.com/job_baker-point-of-sale/artifacts/32b5mga4_image.png" 
        alt="Pains artisanaux" 
        className="w-full h-full object-cover"
        style={{
          objectPosition: 'center center'
        }}
      />
    </div>
  );
};

export default BreadIcon;